import { LANGAUGE_ACTIONS } from './actionTypes';

const LanguageReducer = (state, action) => {
	switch (action.type) {
		case LANGAUGE_ACTIONS.CHANGE_LANG:
			return parseInt(action.languageId);
		default:
			return state;
	}
};

export default LanguageReducer;
